function addCountryCode(phone) {
  const digitsOnly = /\d+/g;
  const BR_COUNTRY_CODE = '55';

  return BR_COUNTRY_CODE + phone.match(digitsOnly).join('');
}

export default addCountryCode;
